import { SubscriptionsAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IGetSubscriptionsDTO, IGetSubscriptionsResponse } from '@/models/subscriptions.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SUBSCRIPTIONS_SLICE_NAME } from './models';

export const getSubscriptions = createAsyncThunk<
  IGetSubscriptionsResponse,
  IGetSubscriptionsDTO,
  { serializedErrorType: IApiError }
>(
  `${SUBSCRIPTIONS_SLICE_NAME}/getSubscriptions`,
  async (data) => {
    const response = await SubscriptionsAPI.getSubscriptions(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteSubscription = createAsyncThunk<void, string, { serializedErrorType: IApiError }>(
  `${SUBSCRIPTIONS_SLICE_NAME}/deleteSubscription`,
  async (id) => {
    const response = await SubscriptionsAPI.deleteSubscription(id);
    return response.data;
  },
  { serializeError: formatApiError },
);
